import { memo } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import { useCommentContext } from "../../../providers";

const CommentBoxInput = () => {
    const {
        message,
        changeMessage,
        addMessage
    } = useCommentContext();

    return (
        <Box
            sx={{
                p: 1
            }}
        >
            <TextField
                fullWidth
                multiline
                size='small'
                value={message}
                minRows={1}
                maxRows={6}
                variant="outlined"
                placeholder='Write your comment here...'
                onChange={event => changeMessage(event.target.value)}
                InputProps={{
                    endAdornment: (
                        <IconButton
                            color='primary'
                            disabled={!message.trim()}
                            onClick={addMessage}
                        >
                            <SendIcon />
                        </IconButton>
                    )
                }}
            />
        </Box>
    );
};

export default memo(CommentBoxInput);
